module.exports = __webpack_public_path__ + "static/img/22.ec69dd9f.svg";